// extracted by mini-css-extract-plugin
export var wrap = "Checkbox-module--wrap--BUvq2";
export var control = "Checkbox-module--control--j85W8";
export var icn = "Checkbox-module--icn--LJhLQ";
export var input = "Checkbox-module--input--x65ew";